import { Injectable, signal } from '@angular/core';

export type UnsavedChangesDecision = 'save' | 'discard' | 'stay';

@Injectable({
  providedIn: 'root'
})
export class UnsavedChangesDialogService {
  readonly visible = signal(false);

  private resolver: ((decision: UnsavedChangesDecision) => void) | null = null;
  private activePrompt: Promise<UnsavedChangesDecision> | null = null;

  confirm(): Promise<UnsavedChangesDecision> {
    if (this.activePrompt) {
      return this.activePrompt;
    }

    this.visible.set(true);
    this.activePrompt = new Promise<UnsavedChangesDecision>((resolve) => {
      this.resolver = resolve;
    });

    return this.activePrompt;
  }

  isWaitingForDecision(): boolean {
    return this.resolver !== null;
  }

  choose(decision: UnsavedChangesDecision): void {
    const resolve = this.resolver;
    this.resolver = null;
    this.activePrompt = null;
    this.visible.set(false);
    resolve?.(decision);
  }
}
